import { render, staticRenderFns } from "./ExpandableItemPTUEmpleado.vue?vue&type=template&id=1d751e50&scoped=true"
import script from "./ExpandableItemPTUEmpleado.vue?vue&type=script&lang=js"
export * from "./ExpandableItemPTUEmpleado.vue?vue&type=script&lang=js"
import style0 from "./ExpandableItemPTUEmpleado.vue?vue&type=style&index=0&id=1d751e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d751e50",
  null
  
)

export default component.exports